import { useInfiniteQuery } from '@tanstack/react-query';
import { getTimeline } from '@/api/timeline';

export function useStudentTimeline(studentId: string, limit = 50) {
  return useInfiniteQuery({
    queryKey: ['timeline', studentId, limit],
    queryFn: ({ pageParam }) =>
      getTimeline(studentId, { cursor: pageParam as string | undefined, limit }),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (lastPage) => lastPage.next_cursor ?? undefined,
    enabled: !!studentId,
  });
}
